import ModelDashboard from '../model-page/ModelDashboard'
import ProjectDashboard from '../project-dashboard/ProjectDashboard'
import { useSelectedWorkflowContext } from '../workflows/SelectedWorkflowProvider'

export default function DashboardRouting() {
  const { selectedWorkflow } = useSelectedWorkflowContext()

  if (selectedWorkflow.project_model_id) {
    return <ModelDashboard />
  }
  return <ProjectDashboard />
}
